import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  chartContainer: {
    color: '#A4A4A4',
    fontSize: 12,
    paddingTop: 15,
    overflow: 'hidden',

    display: 'grid',
    //gridAutoFlow: 'column',
    minWidth: 0,
    maxWidth: '100%',
    width: '100%',
    height: '100%',

    '& .recharts-cartesian-axis-line': {
      stroke: '#e8e8e8'
    },
    '& .recharts-cartesian-axis-tick-line': {
      display: 'none'
    },
    '@media(max-width: 440px)': {
      paddingTop: 5,
    },
  },
  chartArea: {
    minWidth: 0,
    overflow: 'hidden'
  },
  chartLegend: {
    display: 'flex',
    fontSize: 14,
    marginBottom: 0,
    padding: '0 0 40px',
    '@media(max-width: 440px)': {
      display: 'block',
      padding: '0 0 15px',
    },
    '& h5': {
      color: '#4A4A4A',
      fontWeight: 600,
      textTransform: 'capitalize',
      fontSize: '115%',
      margin: '0 15px 0 0',
      padding: 0,
      '@media(max-width: 440px)': {
        margin: '0 0 5px 0',
      },
    }
  },
  chartLegendItem: {
    cursor: 'pointer',
    display: 'flex',
    marginRight: 20,
    alignItems: 'center',
    '@media(max-width: 440px)': {
      marginRight: 0,
      marginBottom: 10,
    },
  },
  chartLegendItemKey: {
    backgroundColor: '#333',
    border: '3px solid #333',
    borderRadius: '100%',
    display: 'block',
    height: 10,
    marginRight: 10,
    width: 10,
    backgroundPosition: 'center',
    backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNjI1IDcuNzgxMjVMMC4xODc1IDQuMzcxMjVMMS4yODA2MyAzLjI5MTg4TDMuNjI1IDUuNjE1NjNMOC43MTkzNyAwLjU2MjVMOS44MTI1IDEuNjQ4NzVMMy42MjUgNy43ODEyNVoiIGZpbGw9IiNmZmZmZmYiLz4KPC9zdmc+)',
  },
  chartLegendItemName: {
    color: '#4a4a4a',
    fontSize: 16,
    lineHeight: '16px'
  }
});
